module.exports = __webpack_public_path__ + "static/media/adobe-xd.fb3b7a1b.png";